import { floor } from "../core/math";
import type { Layout } from "./layout";

export interface CanvasOptions {
  probeId?: string;
}

const preventer = (e: Event): void => {
  e.preventDefault();
};

function disableMobileGestures(canvas: HTMLCanvasElement): void {
  canvas.addEventListener("click", preventer);
  document.addEventListener("touchstart", preventer, { passive: false });
  addEventListener("contextmenu", preventer);
}

export function createCanvas(): CanvasRenderingContext2D {
  const canvas = document.createElement("canvas");
  canvas.style.cssText = `position:fixed;top:0;left:0;display:block;z-index:2;-webkit-font-smoothing:none;-moz-osx-font-smoothing:grayscale;`;
  canvas.style.imageRendering = "pixelated";
  disableMobileGestures(canvas);
  document.body.appendChild(canvas);
  const ctx = canvas.getContext("2d", { alpha: false })!;
  ctx.imageSmoothingEnabled = false;
  ctx.imageSmoothingQuality = "low";
  return ctx;
}

export function resizeLayout(layout: Layout, canvas: HTMLCanvasElement, baseW: number, baseH: number): void {
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const dpr = window.devicePixelRatio || 1;

  const aspect = baseW / baseH;
  const viewAspect = vw / vh;

  let scale: number;
  let canvasCssW: number;
  let canvasCssH: number;
  let canvasLeft: number;
  let canvasTop: number;

  if (viewAspect > aspect) {
    scale = vh / baseH;
    canvasCssW = baseW * scale;
    canvasCssH = vh;
    canvasLeft = (vw - canvasCssW) / 2;
    canvasTop = 0;
  } else {
    scale = vw / baseW;
    canvasCssW = vw;
    canvasCssH = baseH * scale;
    canvasLeft = 0;
    canvasTop = (vh - canvasCssH) / 2;
  }

  canvas.style.width = `${canvasCssW}px`;
  canvas.style.height = `${canvasCssH}px`;
  canvas.style.left = `${canvasLeft}px`;
  canvas.style.top = `${canvasTop}px`;

  canvas.width = floor(canvasCssW * dpr);
  canvas.height = floor(canvasCssH * dpr);

  layout.game.set(0, 0, baseW, baseH);
  layout.safe.set(0, 0, baseW, baseH);
  layout.scale = scale;
  layout.dpr = dpr;
}
